import type { TSystemPracticeStaff, TSystemPracticeStaffListFilters } from "./types";
import { createPathParamCRUD, createPathParam, type NoPathParams } from "@/api/shared/crud";
import { createService } from "@/api/shared";

export * from "./types";

const SLUG = "user/system-practice-staff";

export default createService(SLUG, {
  ...createPathParamCRUD<
    TSystemPracticeStaff,
    NoPathParams,
    TSystemPracticeStaffListFilters,
    Partial<TSystemPracticeStaff>,
    Partial<TSystemPracticeStaff> & { group_ids?: number[] }
  >(SLUG),

  impersonate: createPathParam<
    TSystemPracticeStaff,
    { id: string },
    Partial<TSystemPracticeStaff> | undefined
  >(`${SLUG}/{id}/impersonate`),

  stopImpersonating: createPathParam<
    TSystemPracticeStaff,
    NoPathParams,
    Partial<TSystemPracticeStaff> | undefined
  >(`${SLUG}/stop-impersonating`),
});
